export enum SSOMessage {
  SUCCESS = 'sag-sso-success',
  ERROR = 'sag-sso-error',
}
